import { precalculusLessons } from './lessonsData';
import { logarithmLessons } from './logarithmLessons';
import { trigonometryLessons } from './trigonometryLessons';
import { advancedTopicsLessons } from './advancedTopicsLessons';

export const allPrecalculusLessons = [
  ...precalculusLessons,
  ...logarithmLessons,
  ...trigonometryLessons,
  ...advancedTopicsLessons
];

export const precalculusUnits = [
  {
    id: 'advanced-functions',
    title: 'Advanced Functions',
    description: 'Master polynomial, rational, exponential, logarithmic functions, and function composition',
    lessonCount: 5,
    color: 'from-blue-500 to-cyan-500'
  },
  {
    id: 'trigonometry',
    title: 'Trigonometry',
    description: 'Unit circle, identities, Law of Sines, Law of Cosines, and solving triangles',
    lessonCount: 3,
    color: 'from-purple-500 to-pink-500'
  },
  {
    id: 'complex-numbers',
    title: 'Complex Numbers',
    description: 'Rectangular and polar forms, operations, and De Moivre\'s Theorem',
    lessonCount: 1,
    color: 'from-orange-500 to-red-500'
  },
  {
    id: 'vectors-linear-algebra',
    title: 'Vectors & Linear Algebra',
    description: 'Vector operations, matrices, determinants, and solving systems',
    lessonCount: 1,
    color: 'from-green-500 to-teal-500'
  }
];